import { MruCache } from "owa-mru-cache";
import type ClientItem from "./schema/ClientItem";
import shouldReduceMemoryForDevice from "../utils/shouldReduceMemoryForDevice";

export type MessageMruCache = MruCache<ClientItem>;

type MessageCacheReferenceGetter = () => string | string[];

let messageCache: MessageMruCache | null = null;
let pendingReferenceGetters: MessageCacheReferenceGetter[] = [];

export function registerMessageCacheReference(referenceGetter: MessageCacheReferenceGetter): void {
    if (messageCache) {
        messageCache.registerReference(referenceGetter);
    }
    else {
        pendingReferenceGetters.push(referenceGetter);
    }
}

export default function getMessageCache(): MessageMruCache {
    if (messageCache == null) {
        const cacheSize = shouldReduceMemoryForDevice() ? 10 : 50;
        messageCache = new MruCache<ClientItem>("Messages", cacheSize);
        for (const referenceGetter of pendingReferenceGetters) {
            messageCache.registerReference(referenceGetter);
        }
        pendingReferenceGetters = [];
    }
    return messageCache;
}
